/* formatting helpers (pure) */
export function dur(s: any): string {
  s = Math.max(0, Math.round(+s || 0));
  if (!s) return "—";
  if (s < 60) return s + "s";
  if (s < 3600) return Math.floor(s / 60) + "m " + (s % 60) + "s";
  if (s < 86400) return Math.floor(s / 3600) + "h " + Math.floor((s % 3600) / 60) + "m";
  return Math.floor(s / 86400) + "d " + Math.floor((s % 86400) / 3600) + "h";
}
export function ago(iso?: string | null): string {
  if (!iso) return "—";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 15) return "just now";
  if (s < 60) return Math.round(s) + "s ago";
  if (s < 3600) return Math.floor(s / 60) + "m ago";
  if (s < 86400) return Math.floor(s / 3600) + "h " + Math.floor((s % 3600) / 60) + "m ago";
  return Math.floor(s / 86400) + "d ago";
}
export function since(iso?: string | null): string {
  if (!iso) return "—";
  return dur((Date.now() - new Date(iso).getTime()) / 1000);
}
export function when(iso?: string | null): string {
  if (!iso) return "—";
  const d = new Date(iso), now = new Date(), y = new Date(now);
  y.setDate(now.getDate() - 1);
  const hm = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  if (d.toDateString() === now.toDateString()) return "today " + hm;
  if (d.toDateString() === y.toDateString()) return "yesterday " + hm;
  if (+now - +d < 6 * 86400e3) return d.toLocaleDateString([], { weekday: "short" }) + " " + hm;
  return d.toLocaleDateString([], { day: "numeric", month: "short" }) + " " + hm;
}
export function inFuture(iso?: string | null): string {
  if (!iso) return "—";
  const s = (+new Date(iso) - Date.now()) / 1000;
  return s <= 0 ? "now" : "in " + dur(s);
}
export const gb = (b: number) => (b ? (b / 1073741824).toFixed(b > 10737418240 ? 0 : 1) + " GB" : "—");
export const kbSize = (kb: number) =>
  !kb ? "—" : kb > 1048576 ? (kb / 1048576).toFixed(1) + " GB" : Math.round(kb / 1024) + " MB";
export const lvl = (v: number) => (v >= 85 ? "bad" : v >= 70 ? "warn" : "");
export const statusClass = (s: string): string =>
  (({
    running: "ok", online: "ok", healthy: "ok", success: "ok", ok: "ok", done: "ok", degraded: "warn", restarting: "warn",
    queued: "", stopped: "", offline: "bad", failed: "bad", unhealthy: "bad", unknown: "warn", provisioning: "acc", deploying: "acc",
    cancelled: "warn", waiting: "warn", paused: "warn", rolledback: "warn", exited: "", stale: "warn", never: "warn",
  }) as Record<string, string>)[s] || "";
